export enum FormValidationType {
  Required = 'required',
  Pattern = 'pattern',
  Validate = 'validate',
}
